import * as React from 'react';
export const Group = (props) => {
    // TODO: find a better way to filter through non-HTML attribute noise
    const { baseId, state, setState, onChange, ...propsWithoutState } = props;
    const { as = 'div', children, ...htmlProps } = propsWithoutState;
    return React.createElement(as, htmlProps, children);
};
Group.displayName = 'Group';
